module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.13561/js/img/white_sprocket.svg"